module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-BoldItalic.c783051f.ttf";